import { render, staticRenderFns } from "./PedidoEditPage.vue?vue&type=template&id=ea071e1c&lang=pug&"
import script from "./PedidoEditPage.ts?vue&type=script&lang=ts&"
export * from "./PedidoEditPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports